module.exports = __webpack_public_path__ + "img/wifi.53e59edd.svg";